import React from 'react'
import {CircularProgress} from "@mui/material";
import useLoadScoredScene from "../../utils/useLoadScoredScene";
import ScoredSceneCardBasic from "./ScoredSceneCardBasic";

const ScoredSceneCardBasicLoadable = ({
                                          scoredSceneKey,

                                          // True is only allowed in case it is used within react-router-dom
                                          clickable = false
                                      }) => {

    const {selectedScoredScene, loading} = useLoadScoredScene(null, scoredSceneKey)

    if (loading) {
        return <CircularProgress/>
    }

    return <ScoredSceneCardBasic scoredScene={selectedScoredScene} thumbnailHeight={80} logoSize={20}
                                 clickable={clickable}/>
}

export default ScoredSceneCardBasicLoadable
